import React from 'react'

const CheckBoxCheckedIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      fontSize={'inherit'}
    >
      <circle cx="11" cy="11" r="11" fill="currentColor" />
      <path
        d="M16.8665 8.06675L8.79985 16.1334L5.13318 12.4667"
        fill="currentColor"
      />
      <path
        d="M16.8665 8.06675L8.79985 16.1334L5.13318 12.4667"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckBoxCheckedIcon
